export default __webpack_public_path__ + "static/media/pathway_active_w.7610ef74.svg";